module.exports = __webpack_public_path__ + "assets/images/opera-house.c246e7bd613dfd33c8dcd6595f58ab4b.svg";